export default __webpack_public_path__ + "static/media/jak_slideshow_thumb.7df509f8.jpg";